export const ShopifyCookieKey = 'shopify-token';
export const Shopify = 'Shopify';
